<template>
	<div class="menus-wrap">
		<head-info style="margin-bottom: 50px;"></head-info>
		<div id="print-wrap">
			<div class="photo"><img v-if="detail.photo" :src="detail.photo" alt="" /></div>
				<template v-if="detail.erj1">
					<h3 style="font-size: 24px;text-align:center;">{{detail.erj1}}</h3>
					<h3 style="font-size: 24px;text-align:center;">{{detail.erj2}}</h3>
					<h3 style="font-size: 24px;text-align:center;margin-bottom: 20px;">面试通知书</h3>
				</template>
				<template v-else>
					<h3 style="font-size: 24px;text-align:center;">{{detail.examination_name}}</h3>
					<h3 style="font-size: 24px;text-align:center;margin-bottom: 20px;">面试通知书</h3>
				</template>
				<el-descriptions :column="2" border>
					<el-descriptions-item :labelStyle="{ width: '100px' }" :contentStyle="{ width: '200px' }" label="姓名">{{ detail.name }}</el-descriptions-item>
					<el-descriptions-item label="性别">{{ detail.gender || '-' }}</el-descriptions-item>
					<!-- <el-descriptions-item
					:labelStyle="{ width: '0', backgroundColor: '#fff', border: '1px solid transparent', borderTopColor: '#000000' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#000000', borderTopColor: '#000000' }"
					></el-descriptions-item> -->
					<el-descriptions-item :labelStyle="{ width: '100px' }" :contentStyle="{ width: '220px' }" label="身份证号">{{detail.card_id}}</el-descriptions-item>
					<el-descriptions-item label="面试语种">{{ detail.interview_number || '-' }}</el-descriptions-item>
					<el-descriptions-item label="报考单位">{{ detail.interview_time || '-' }}</el-descriptions-item>
					<el-descriptions-item label="报考岗位">{{ detail.interview_type || '-' }}</el-descriptions-item>
					<el-descriptions-item label="面试时间">{{ detail.interview_datetime || '-' }}</el-descriptions-item>
					<el-descriptions-item label="面试组别">{{ detail.interview_wait || '-' }}</el-descriptions-item>
					<!-- <el-descriptions-item
					:labelStyle="{ backgroundColor: '#fff', border: '1px solid transparent' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#000000' }"
					></el-descriptions-item> -->
					<el-descriptions-item :span="2" label="面试地点">{{ detail.interview_address || '-' }}</el-descriptions-item>
					<!-- <el-descriptions-item
					:labelStyle="{ backgroundColor: '#fff', border: '1px solid transparent', borderBottomColor: '#000000' }"
					:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#000000', borderBottomColor: '#000000' }"
					></el-descriptions-item> -->
				</el-descriptions>
				<div style="font-weight: normal;" v-html="detail.advices"></div>
		</div>
		<div v-if="mobile === 0" class="footer-btns"><el-button type="primary" v-print="printObj">点击打印</el-button></div>
		<div v-else class="footer-btns"><el-button type="primary" @click="downloadClick">点击下载</el-button></div>
	</div>
</template>

<script>
import HeadInfo from '@/components/HeadInfo';
import { reqGetInterviewCandidateInfo, reqPrintInterview } from '@/api';
import { Message } from 'element-ui';
import {mapGetters,mapState} from "vuex";
import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';
import store from '@/store';
export default {
	components: {
		HeadInfo
	},
	data() {
		return {
			detail: {},
			printObj: {
				id: 'print-wrap',
				openCallback() {
					reqPrintInterview();
				}
			}
		};
	},
	computed: {
		...mapState({
			mobile: state => state.system.mobile,
			examination_name: state => state.system.examInfo.examination_name,
		}),
		isInterview() {
			try {
				return this.detail.is_interview === 0 ? '未获得' : this.detail.is_interview === 1 ? '已获得' : '-';
			} catch (e) {
				//TODO handle the exception
				return '-';
			}
		},
		...mapGetters('user',['GET_USER_INFO']),
	},
	beforeRouteEnter(to, form, next) {
		reqGetInterviewCandidateInfo().then(res => {
			if (res.data.interview_before) {
				Message.info('未到打印面试通知书时间 打印时间：2025-01-13 00:00:00 至 2025-01-17 23:59:59');
				next(false);
			} else if (res.data.interview_open) {
				if (res.data.is_interview === 1) {
					if (res.data.advices) {
						next(vm => {
							vm.detail = vm.GET_USER_INFO;
							Object.assign(vm.detail, res.data);
						});
					} else {
						Message.info('暂未设置面试通知');
						next(false);
					}
				} else {
					Message.info('考生你好，3月17日进行蒙古语水平测试，测试合格方可打印面试通知书。');
					next(false);
				}
			} else if (res.data.interview_end) {
				Message.info('打印面试通知时间已过');
				next(false);
			}
		});
	},
	methods: {
		 downloadClick() {
		      var title = `${this.detail.name}-${this.detail.examination_name}面试准考证`;
		      html2Canvas(document.querySelector('#print-wrap'), {
			allowTaint: true,
			    scale: 2,
			    dpi: 600,//导出pdf清晰度
			    useCORS: true
		      }).then(function (canvas) {
			var pdf = new JsPDF('p', 'mm', 'a4');    //A4纸，纵向
			var ctx = canvas.getContext('2d'),
			  a4w = 190, a4h = 277,    //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
			  imgHeight = Math.floor(a4h * canvas.width / a4w),    //按A4显示比例换算一页图像的像素高度
			  renderedHeight = 0;
		 
			while (renderedHeight < canvas.height) {
			  var page = document.createElement("canvas");
			  page.width = canvas.width;
			  page.height = Math.min(imgHeight, canvas.height - renderedHeight);//可能内容不足一页
		 
			  //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
			  page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
			  pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width));    //添加图像到页面，保留10mm边距
			  renderedHeight += imgHeight;
			  if (renderedHeight < canvas.height)
			    pdf.addPage();//如果后面还有内容，添加一个空页
			  // delete page;
			}
			reqPrintInterview();
			pdf.save(title + '.pdf');
		      });
		    },
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/color.scss';
#print-wrap {
	position: relative;
	margin: auto;
	max-width: 780px;

	.photo {
		width: 110px;
		height: 160px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 150px;
		right: 90px;
		transform: translate(50%, -50%);

		img {
			max-width: 100%;
			max-height: 100%;
			object-fit: contain;
		}
	}
	pre {
		font-family: "Microsoft YaHei";
		white-space: pre-wrap;
		word-wrap: break-word;
		tab-size: 7;
		-moz-tab-size: 7;
		-o-tab-size: 7;

	}

	::v-deep.el-descriptions {

		.el-descriptions__header {
			justify-content: center;
			font-weight: bold;
			color: #000000;

			.el-descriptions__title {
				font-weight: bold;
			}
		}

		.el-descriptions__body {
			.el-descriptions__table .el-descriptions-item__cell {
				line-height: 20px;
				color: #000000;
				border: 1px solid;
				borderColor: #000000;
			}
		}
	}
}
</style>